/**
 * Can deals (children) live in this stage? Deals are created in the
 * pipeline's FIRST deal-enabled stage (`isChild`) and only ever move forward,
 * so every stage at or after that one can hold them — and only those stages
 * get the "Prioritise latest deal" follow-up option (rule 9).
 *
 * `ownIsChild` is the editor's LIVE toggle for the stage being edited: turning
 * "deals" on in the form should offer the option before the stage is saved.
 */
export function stageCanHoldDeals(
  stages: ReadonlyArray<{ order: number; isChild?: boolean }> | undefined,
  stageOrder: number | null | undefined,
  ownIsChild: boolean,
): boolean {
  if (ownIsChild) return true;
  if (stageOrder == null || !Number.isFinite(Number(stageOrder))) return false;
  let firstChildOrder: number | null = null;
  for (const s of stages ?? []) {
    if (!s.isChild) continue;
    if (firstChildOrder == null || s.order < firstChildOrder) {
      firstChildOrder = s.order;
    }
  }
  return firstChildOrder != null && Number(stageOrder) >= firstChildOrder;
}
